import React, { useState } from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PricingPlanModal from '../../../modules/accounts/components/PricingPlanModal';

const PremiumUpgradeScreen = ({ 
  title = "Upgrade to Continue",
  titleHead = "",
  titleDescription = "",
  message = "Your current plan doesn't include access to this feature. Please choose a plan to continue and unlock full functionality",
  billingRoute = ''
}) => {
  const navigate = useNavigate();
  const [isUpgradeOpen, setIsUpgradeOpen] = useState(false);
  const { currentBrand } = useSelector((state) => state.app);

  const handleChoosePlan = () => {
    if (currentBrand?.brand_id) {
      setIsUpgradeOpen(true);
    } else {
      navigate(billingRoute);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center py-20 px-4 text-center bg-[var(--background)] rounded-2xl shadow-sm border border-[var(--border-input)] min-h-[500px]">
      {titleHead && (
        <h2 className="mb-2 text-xl weight-semibold text-[var(--textBlack)]">
          {titleHead}
        </h2>
      )}
      {titleDescription && (
        <p className="text-sm text-[var(--font-600)] max-w-lg mb-5 block">
          {titleDescription}
        </p>
      )}
      <div className="mb-5">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M30 55C43.8071 55 55 43.8071 55 30C55 16.1929 43.8071 5 30 5C16.1929 5 5 16.1929 5 30C5 43.8071 16.1929 55 30 55Z" fill="var(--lightRed)"/>
          <path d="M30 40V40.1" stroke="var(--red)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M30 20V32" stroke="var(--red)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      
      <h2 className="mb-2 text-xl weight-semibold text-[var(--textBlack)]">
        {title}
      </h2>
      
      <p className="text-sm text-[var(--font-600)] max-w-lg mb-6 block">
        {message}
      </p>
      
      <Button 
        type="primary"
        size="large"
        className="h-12 px-10 rounded-md text-sm weight-semibold bg-[var(--new-primary)] hover:!bg-[var(--new-primary)] border-none shadow-md"
        onClick={handleChoosePlan}
      >
        Choose a plan
      </Button>

      {currentBrand?.brand_id && (
        <PricingPlanModal
          open={isUpgradeOpen}
          setOpen={setIsUpgradeOpen}
          brandId={currentBrand.brand_id}
        />
      )}
    </div>
  );
};

export default PremiumUpgradeScreen;
